/** Distributor that sells a batch of Breakout-level access codes. */
export enum AccessCodeVendor {
  vitalSource = 'vitalSource',
  kortext = 'kortext',
}

export const accessCodeVendorLabels: Record<AccessCodeVendor, string> = {
  [AccessCodeVendor.vitalSource]: 'VitalSource',
  [AccessCodeVendor.kortext]: 'Kortext',
}
